const Logo = ({ dark = false, className = "h-12 md:h-14" }) => (
  <img
    src="/assets/logo.png"
    alt="Stelcore Development logo"
    className={`${className} w-auto`}
    style={dark ? { filter: "invert(1)", mixBlendMode: "screen" } : { mixBlendMode: "multiply" }}
    data-testid={dark ? "logo-dark" : "logo"}
  />
);

export default Logo;
